"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.privateRouter = exports.publicRouter = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
const c = (0, core_1.initContract)();
const ApiSecret = zod_1.z.object({
    clientId: zod_1.z.string(),
    clientSecret: zod_1.z.string(),
});
const pathPrefix = '/users';
const privateRoutes = c.router({
    createApiCredentials: {
        method: 'POST',
        path: '/current/api-credentials',
        body: schemas_1.EmptyBody,
        responses: Object.assign(Object.assign({}, schemas_1.AuthErrorResponse), { 200: ApiSecret }),
    },
    findApiCredentials: {
        method: 'GET',
        path: '/current/api-credentials',
        responses: {
            200: zod_1.z.object({ credentials: schemas_1.ApiCredentials }),
        },
    },
    deleteApiCredential: {
        method: 'DELETE',
        path: '/current/api-credentials/:id',
        body: schemas_1.EmptyBody,
        responses: Object.assign(Object.assign({}, schemas_1.AuthErrorResponse), { 200: schemas_1.EmptyBody }),
    },
});
const publicRoutes = c.router({
    getUserSelf: {
        method: 'GET',
        path: '/current',
        responses: {
            200: schemas_1.GetUserSelfResponse,
        },
    },
});
const allRoutes = Object.assign(Object.assign({}, privateRoutes), publicRoutes);
exports.publicRouter = c.router(publicRoutes, { pathPrefix });
exports.privateRouter = c.router(allRoutes, { pathPrefix });
